export function scrollToTop(behavior: 'smooth' | 'instant' | 'auto' = 'auto') {
  window.scrollTo({
    top: 0,
    behavior,
  })
}
